module.exports = __webpack_public_path__ + "img/logo_dinamo_high_dark.630843f3.png";